// extracted by mini-css-extract-plugin
export default {"block":"Question_block__KNT2N","question":"Question_question__AGD+t"};